import './badge.css';

const BadgePayments = ({ text, type }) => {
  return (
    <div className={`badge-payments ${type}`}>
      {text}
    </div>
  );
};

export default BadgePayments;
